import styled, { css } from "styled-components"

export const StyledSpacer = styled.hr`
  margin: 32px 0;
  border: none;

  ${({ transparent }) =>
    !transparent &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colors.fields.spacer};
    `}

  ${({ transparent }) =>
    transparent &&
    css`
      border-top: none;
    `}
`
